const Checkbox = {
  parts: ["control"],
  baseStyle: { control: { borderColor: "gray.medium" } },
};

export default Checkbox;
